import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useSite } from "@/context/SiteContext";
import { Switch } from "@/components/ui/switch";

const NAV_OPTIONS = [
  { key: "inicio", label: "Início" },
  { key: "empresas", label: "Empresas" },
  { key: "cupons", label: "Cupons" },
  { key: "noticias", label: "Notícias" },
  { key: "mais", label: "Mais" },
];

const Settings = () => {
  const { settings, reload } = useSite();
  const [form, setForm] = useState(null);

  useEffect(() => { if (settings) setForm({ ...settings, bottom_nav: settings.bottom_nav || [] }); }, [settings]);
  if (!form) return null;

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));
  const toggleNav = (key) => {
    const arr = form.bottom_nav || [];
    set("bottom_nav", arr.includes(key) ? arr.filter((x) => x !== key) : [...arr, key]);
  };

  const save = async () => {
    try {
      await api.put("/admin/settings", form);
      toast.success("Configurações salvas");
      reload();
    } catch (e) {
      toast.error("Erro ao salvar");
    }
  };

  const input = "w-full px-3 py-2 rounded-lg border border-border bg-background outline-none focus:border-primary text-sm";

  return (
    <div>
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-bold font-heading text-slate-900">Configurações</h1>
          <p className="text-sm text-muted-foreground">Contatos e navegação</p>
        </div>
        <button onClick={save} data-testid="save-settings-btn" className="flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-4 py-2.5 text-sm font-semibold active:scale-95 transition-transform">
          <Save className="w-4 h-4" /> Salvar
        </button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <div className="bg-white rounded-2xl border border-border p-5 space-y-4">
          <h2 className="font-bold font-heading text-slate-900">Contato & Redes</h2>
          <div>
            <label className="text-sm font-medium mb-1 block">WhatsApp geral (só números com DDI)</label>
            <input value={form.whatsapp || ""} onChange={(e) => set("whatsapp", e.target.value)} placeholder="5583999999999" className={input} data-testid="setting-whatsapp" />
          </div>
          <div>
            <label className="text-sm font-medium mb-1 block">Instagram (link)</label>
            <input value={form.instagram || ""} onChange={(e) => set("instagram", e.target.value)} className={input} />
          </div>
          <div>
            <label className="text-sm font-medium mb-1 block">Texto da pesquisa</label>
            <input value={form.search_placeholder || ""} onChange={(e) => set("search_placeholder", e.target.value)} className={input} />
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-border p-5">
          <h2 className="font-bold font-heading text-slate-900 mb-1">Barra inferior (mobile)</h2>
          <p className="text-sm text-muted-foreground mb-3">Escolha quais atalhos aparecem</p>
          <div className="space-y-2">
            {NAV_OPTIONS.map((o) => (
              <div key={o.key} className="flex items-center justify-between py-1">
                <span className="text-sm font-medium">{o.label}</span>
                <Switch checked={(form.bottom_nav || []).includes(o.key)} onCheckedChange={() => toggleNav(o.key)} data-testid={`nav-toggle-${o.key}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
